<template>
  <div class="institution-details-grid two-columns">
    <div class="institution-details-grid-column">
      <BaseBox display="flex" flex-direction="column" gap="lg">
        <BaseCard>
          <BaseCardBody>
            <BaseBox
              display="flex"
              :flex-direction="{ '': 'column', sm: 'row' }"
              align-items="center"
              gap="md"
            >
              <VueSkeletonLoader type="circle" :width="112" :height="112" />
              <div>
                <VueSkeletonLoader
                  class="mb-2"
                  :width="300"
                  :height="30"
                  rounded
                />
                <VueSkeletonLoader :width="200" :height="25" rounded />
              </div>
            </BaseBox>
          </BaseCardBody>
        </BaseCard>
        <BaseCard>
          <BaseCardBody>
            <VueSkeletonLoader class="w-100" :height="200" />
          </BaseCardBody>
        </BaseCard>
        <BaseCard>
          <BaseCardBody>
            <VueSkeletonLoader class="w-100" :height="200" />
          </BaseCardBody>
        </BaseCard>
      </BaseBox>
    </div>

    <div class="institution-details-grid-column">
      <BaseCard>
        <BaseCardGroup>
          <BaseBox display="flex" align-items="center" justify-content="center">
            <VueSkeletonLoader
              class="text-center"
              :width="200"
              :height="30"
              rounded
            />
          </BaseBox>
        </BaseCardGroup>
        <BaseCardGroup>
          <BaseCardBody>
            <VueSkeletonLoader class="w-100" :height="400" />
          </BaseCardBody>
        </BaseCardGroup>
      </BaseCard>
    </div>
  </div>
</template>

<script>
import VueSkeletonLoader from "skeleton-loader-vue";

export default {
  name: "InstitutionDetailsSkeleton",
  components: {
    VueSkeletonLoader
  }
};
</script>
